import React from 'react'
import { Link } from 'react-router-dom'
import { memberPagePath } from '../../../../../../api-new/state/invite-outcome'

export { ALREADY_MEMBER_MESSAGE, inviteOutcome, memberPagePath } from '../../../../../../api-new/state/invite-outcome'

// The members an invite skipped (owner ruling 2026-10-09): each with the
// reason and a link to their member page, where their access is changed.
// onNavigate: called before following a link (the bulk progress modal
// closes itself first).
export const InviteSkipped = ({ skipped, onNavigate }) => {
  if (!skipped || skipped.length === 0) {
    return null
  }

  return (
    <div className="alert alert-warning m-1" role="status">
      <div className="fw-bold mb-1">Skipped: already members</div>
      <ul className="list-unstyled mb-0">
        {skipped.map((item, i) =>
          <li key={i} className="d-flex flex-wrap align-items-center py-1">
            <span className="me-2 text-break">
              {item.email}
            </span>
            <span className="me-2 text-muted">
              {item.message}
            </span>
            <Link className="btn btn-sm btn-outline-primary" to={memberPagePath(item.userID)} onClick={() => onNavigate && onNavigate()}>
              Open their page
            </Link>
          </li>
        )}
      </ul>
    </div>
  )
}
